import React, { useState } from "react";
import { Box, Typography, InputBase, ButtonBase } from "@mui/material";
import { admin_base_url } from "../../Global";

const Settings = () => {
  const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("accessToken");

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    setStatus(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) {
      setStatus({ type: "error", message: "New passwords do not match." });
      return;
    }
    if (form.newPassword.length < 8) {
      setStatus({ type: "error", message: "Password must be at least 8 characters." });
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(admin_base_url + "/update-password", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to update password.");
      setStatus({ type: "success", message: "Password updated successfully." });
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      setStatus({ type: "error", message: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box style={{ padding: "32px", display: "flex", flexDirection: "column", gap: "32px", maxWidth: "520px" }}>
      <Box>
        <Typography style={{ color: "white", fontSize: "24px", fontWeight: 700, fontFamily: "Gilroy, sans-serif" }}>
          Settings
        </Typography>
        <Typography style={{ color: "#6b7280", fontSize: "13px", fontFamily: "Gilroy, sans-serif", marginTop: "4px" }}>
          Manage your account preferences
        </Typography>
      </Box>

      {/* Change Password */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        style={{
          background: "#111827", borderRadius: "12px",
          border: "1px solid #1f2937", padding: "24px",
          display: "flex", flexDirection: "column", gap: "16px",
        }}
      >
        <Typography style={{ color: "white", fontSize: "16px", fontWeight: 700, fontFamily: "Gilroy, sans-serif" }}>
          Change Password
        </Typography>

        <Field label="Current Password">
          <InputBase
            type="password"
            value={form.currentPassword}
            onChange={handleChange("currentPassword")}
            required
            placeholder="Enter current password"
            sx={inputSx}
          />
        </Field>

        <Field label="New Password">
          <InputBase
            type="password"
            value={form.newPassword}
            onChange={handleChange("newPassword")}
            required
            placeholder="Min. 8 characters"
            sx={inputSx}
          />
        </Field>

        <Field label="Confirm New Password">
          <InputBase
            type="password"
            value={form.confirmPassword}
            onChange={handleChange("confirmPassword")}
            required
            placeholder="Repeat new password"
            sx={inputSx}
          />
        </Field>

        {status && (
          <Box style={{
            borderRadius: "8px", padding: "10px 14px",
            background: status.type === "success" ? "rgba(22,163,74,0.12)" : "rgba(239,68,68,0.12)",
            border: `1px solid ${status.type === "success" ? "rgba(22,163,74,0.3)" : "rgba(239,68,68,0.3)"}`,
          }}>
            <Typography style={{
              color: status.type === "success" ? "#4ade80" : "#f87171",
              fontSize: "13px", fontFamily: "Gilroy, sans-serif",
            }}>
              {status.message}
            </Typography>
          </Box>
        )}

        <ButtonBase
          type="submit"
          disabled={loading}
          style={{
            background: "white", color: "#111827",
            borderRadius: "8px", padding: "10px 24px",
            fontFamily: "Gilroy, sans-serif", fontSize: "14px",
            fontWeight: 700, alignSelf: "flex-start",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Updating..." : "Update Password"}
        </ButtonBase>
      </Box>
    </Box>
  );
};

const inputSx = {
  background: "#1f2937", borderRadius: "8px",
  padding: "0 14px", height: "44px", color: "white",
  fontFamily: "Gilroy, sans-serif", fontSize: "13px",
  border: "1px solid #374151", width: "100%",
};

const Field = ({ label, children }) => (
  <Box style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
    <Typography style={{ color: "#9ca3af", fontSize: "12px", fontFamily: "Gilroy, sans-serif", textTransform: "capitalize" }}>
      {label}
    </Typography>
    {children}
  </Box>
);

export default Settings;
